import { some as _some } from 'lodash-es';
import { useMemo } from 'react';
import { makeStyles } from 'tss-react/mui';
import Favorite from '@mui/icons-material/Favorite';
import MaterialLink from './material-link';
import { useAppContext } from '../contexts/app';
import type { User } from '../types/User';

const useStyles = makeStyles()((theme) => ({
  link: {
    display: 'inline-flex',
    alignItems: 'center',
  },
  userLink: {
    display: 'inline-flex',
    alignItems: 'center',
    minWidth: 0,
    overflowWrap: 'anywhere',
  },
  avatar: {
    height: 20,
    width: 20,
    flexShrink: 0,
    borderRadius: '50%',
    objectFit: 'cover' as const,
    marginRight: theme.spacing(0.5),
  },
  iconWrapper: {
    marginLeft: theme.spacing(0.5),
    display: 'inline-flex',
    alignItems: 'center',
  },
  followingIcon: {
    color: theme.palette.secondary.dark,
    fontSize: 20,
  },
}));

type Props = {
  user: User;
  className?: string;
  simple?: boolean;
};

const HostUser = ({ user, className, simple = false, ...rest }: Props) => {
  const { classes, cx } = useStyles();
  const { loggedInUser } = useAppContext();

  const following = useMemo(() => {
    if (simple || !loggedInUser) {
      return false;
    }
    return _some(loggedInUser.userFollows, ({ followingUser: { id: followingUserId } }) => (
      followingUserId === user.id
    ));
  }, [simple, loggedInUser, user]);

  return (
    <div className={cx(classes.link, className)}>
      {user.avatar && (
        <img
          alt={user.displayName}
          src={user.avatar.small.url}
          width={20}
          height={20}
          className={classes.avatar}
        />
      )}
      <MaterialLink
        href={`/people/${user.username}`}
        className={classes.userLink}
        {...rest}
      >
        {user.displayName}
      </MaterialLink>
      {following && (
        <span
          className={classes.iconWrapper}
          title="You're following this person"
        >
          <Favorite className={classes.followingIcon} />
        </span>
      )}
    </div>
  );
};

export default HostUser;
